module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Show less":"Show less","Show more":"Show more...","Add your comment here":"Add your comment here","Comment":"Comment","Reply":"Reply"},"it":{"Show less":"Mostra meno","Show more":"Mostra di più","Add your comment here":"Aggiungi il tuo commento qui","Comment":"Commento","Reply":"Risposta"}}')
  delete Component.options._Ctor
}
